/**
 * Lightweight client-side validation for partner forms.
 * Enhances native validation — does not replace it (no novalidate).
 * Adds aria-invalid and .field--error on focusout for invalid fields.
 */
(function () {
  const form = document.getElementById('PartnerForm');
  if (!form) return;

  /* Sync checkbox groups into hidden fields before submit */
  form.addEventListener('submit', function () {
    form.querySelectorAll('[data-checkbox-group]').forEach(function (group) {
      var id = group.getAttribute('data-checkbox-group');
      var hidden = form.querySelector('[data-checkbox-collect="' + id + '"]');
      if (!hidden) return;
      var checked = [];
      group.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        checked.push(cb.value);
      });
      hidden.value = checked.join(', ');
    });
  });

  form.addEventListener('focusout', function (event) {
    const field = event.target;
    if (!field.willValidate) return;

    if (!field.checkValidity()) {
      field.setAttribute('aria-invalid', 'true');
      const wrapper = field.closest('.field');
      if (wrapper) wrapper.classList.add('field--error');
    } else {
      field.removeAttribute('aria-invalid');
      const wrapper = field.closest('.field');
      if (wrapper) wrapper.classList.remove('field--error');
    }
  });

  form.addEventListener('input', function (event) {
    const field = event.target;
    if (field.getAttribute('aria-invalid') === 'true' && field.checkValidity()) {
      field.removeAttribute('aria-invalid');
      const wrapper = field.closest('.field');
      if (wrapper) wrapper.classList.remove('field--error');
    }
  });
})();
